export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';
export const OIDC_AUTHORITY = process.env.REACT_APP_OIDC_AUTHORITY;
export const CLIENT_ID = process.env.REACT_APP_OIDC_CLIENT_ID;
export const REDIRECT_URI = process.env.REACT_APP_OIDC_REDIRECT_URI;
export const API_BASE_LOG_URL = process.env.REACT_APP_API_BASE_LOG_URL || 'https://gateway.mobilemed.com.br/lambda/audit-log-reader'

export const OIDC_DEFAULT_USER_POOL_ID = process.env.REACT_APP_OIDC_DEFAULT_USER_POOL_ID;
export const OIDC_DEFAULT_TENANT = process.env.REACT_APP_OIDC_DEFAULT_TENANT;

// Elastic APM (RUM) - keep values non-sensitive (no secret token in browser).
export const apmEnabled = (process.env.REACT_APP_APM_ENABLED ?? "false").toLowerCase() === "true";
export const APM_SERVER_URL = process.env.REACT_APP_APM_SERVER_URL || "";
export const APM_SERVICE_NAME_FRONT = process.env.REACT_APP_APM_SERVICE_NAME_FRONT || "";
export const APM_ENVIRONMENT = process.env.REACT_APP_APM_ENVIRONMENT || "";

// Distributed tracing origins (bases that should receive traceparent/tracestate).
export const apiUrl = API_BASE_URL;
export const apiMessageUrl = API_BASE_LOG_URL;

export const MAX_AUTH_AGE_SENSITIVE = Number(process.env.REACT_APP_MAX_AUTH_AGE_SENSITIVE) || 600;
export const MAX_AUTH_AGE_EDIT = Number(process.env.REACT_APP_MAX_AUTH_AGE_EDIT) || 14400;
